import React from "react";
import LeadingText from "../LeadingText";
import SupportingText from "../SupportingText";
import { LetterX, Glasses } from "../Icons";
import BaseButton from "../BaseButton";
import LazyImage from "../LazyImage";
import { formatPrice } from "../helpers";

export default function CartItemRow({
  isLoggedIn,
  articleID,
  brand,
  price,
  mediaDataMedium,
  onClick
}) {
  return (
    <div className="w-full flex items-center justify-center py-2">
      <div className="w-1/2 pr-3">
        <LazyImage
          src={mediaDataMedium.jpgUrl}
          aspectRatio={mediaDataMedium.ratio * 100 || 40}
          fadeInDuration={0.7}
          bgColor="grey-lighter"
          fallback={() => (
            <div className="w-full h-full flex flex-col items-center justify-center">
              <Glasses fill="#8795A1" stroke="#606F7B" />
            </div>
          )}
        />
      </div>
      <div className="w-1/2 border-red-lightest border-l-4 pl-3">
        <div className="w-full flex items-center">
          <div className="flex flex-col items-start justify-center">
            <LeadingText
              textSize="base"
              fontColor="grey-darkest"
              fontWeight="normal"
            >
              {articleID}
            </LeadingText>
            <div className="pt-1">
              <SupportingText fontWeight="thin">{brand}</SupportingText>
            </div>
            <div className="pt-1">
              <SupportingText textColor="red-light" fontWeight="thin">
                {isLoggedIn ? `${formatPrice(price)} €` : ""}
              </SupportingText>
            </div>
          </div>
          <div className="ml-auto">
            <BaseButton onClick={onClick}>
              <LetterX fill="#FCEBEA" stroke="#EF5753" width="15" height="15" />
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/CartItemRow/CartItemRow.js